var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.52537 17.5H14.4753C16.8323 17.5 17.7717 16.303 17.8828 14.8438L18.3268 8.99296C18.4464 7.46296 16.9775 6.16671 15.1243 6.16671C14.6034 6.16671 14.1251 5.91879 13.886 5.53629L13.2711 4.50921C12.8783 3.86462 11.8535 3.33337 10.9824 3.33337H9.02674C8.14716 3.33337 7.12235 3.86462 6.72951 4.50921L6.11463 5.53629C5.87551 5.91879 5.39727 6.16671 4.87632 6.16671C3.02313 6.16671 1.55425 7.46296 1.67381 8.99296L2.11789 14.8438C2.22037 16.303 3.16831 17.5 5.52537 17.5Z",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0003 14.1667C11.492 14.1667 12.7087 12.95 12.7087 11.4583C12.7087 9.96667 11.492 8.75 10.0003 8.75C8.50866 8.75 7.29199 9.96667 7.29199 11.4583C7.29199 12.95 8.50866 14.1667 10.0003 14.1667Z",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ee83ad66c9d51333c1cd10b20bc8548a.svg";
export { ForwardRef as ReactComponent };